import { Component, Input, OnInit } from '@angular/core';
import { InputType } from 'zlib';

@Component({
  selector: 'app-advanced-map-pin',
  templateUrl: './advanced-map-pin.component.html',
  styleUrls: ['./advanced-map-pin.component.scss'],
  standalone: false
})
export class AdvancedMapPinComponent implements OnInit {

  color: string;
  img: string;
  clusterImg: string;
  text: string
  type: InputType;
  isCluster: boolean;

  clusterCount: string;

  @Input() inputColor: string;
  @Input() inputImg: string;
  @Input() inputClusterImg: string;

  @Input() inputText: string;
  @Input() inputType: string;

  @Input() inputIsCluster: boolean;
  @Input() inputClusterCount: string;
  @Input() isHvPole: boolean = false;

  ngOnInit(): void {
    this.color = this.inputColor;
    this.img = this.inputImg;
    this.text = this.inputText;
    this.type = this.inputType;
    this.isCluster = this.inputIsCluster;
    this.clusterCount = this.inputClusterCount;
    this.clusterImg = this.inputClusterImg;

  }
}
